import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ path, ...props }) => {
  const isLoggedIn = useSelector(state=>state.auth.userLoggedIn);
  return (
    <>
      {isLoggedIn ? (
        <Route to={path} {...props} />
      ) : (
        <Redirect to={{ pathname: "/login", state: { from: path } }} />
      )}
    </>
  );
};

export default ProtectedRoute;
